import { render, staticRenderFns } from "./HrTrainCertSpecial.vue?vue&type=template&id=546db7c0&scoped=true&"
import script from "./HrTrainCertSpecial.vue?vue&type=script&lang=js&"
export * from "./HrTrainCertSpecial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546db7c0",
  null
  
)

export default component.exports